import { Typography, TypographyProps } from '@mui/material'
import { useTranslationOrText } from '../hooks'

export interface TranslationOrTextProps {
  text?: string
  translationId?: string
}

export const TranslationOrText = ({
  text,
  translationId
}: TranslationOrTextProps) => {
  const translationOrText = useTranslationOrText(translationId, text)

  return <>{translationOrText}</>
}

export interface StyledTranslationOrTextProps extends TranslationOrTextProps {
  typographyProps?: TypographyProps
}

export const StyledTranslationOrText = ({
  typographyProps,
  ...rest
}: StyledTranslationOrTextProps) => {
  return (
    <Typography {...typographyProps}>
      <TranslationOrText {...rest} />
    </Typography>
  )
}
